import { Show } from "solid-js";
import type { RecordKind } from "../api/types";
import { t } from "../i18n";
import { newRecordLabels } from "../lib/records";

/** "Новый рекорд · макс. вес": rendered only when kinds is non-empty. */
export default function RecordBadge(props: { kinds: readonly RecordKind[] | undefined }) {
  return (
    <Show when={props.kinds?.length}>
      <span class="record-badge" data-testid="record-badge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M8 4h8v5a4 4 0 0 1-8 0V4z" />
          <path d="M8 6H5v1a3 3 0 0 0 3 3M16 6h3v1a3 3 0 0 1-3 3" />
          <path d="M12 13v4M9 20h6M10 17h4" />
        </svg>
        <span>
          {t("NEW_RECORD")} · {newRecordLabels(props.kinds)}
        </span>
      </span>
    </Show>
  );
}
